export default {
  id: "id",
  title: "title",
  description: "description",
  createdAt: "created_at",
  adderName:"admins.name"
};
